(function() {
  "use strict";
  var fired = false;

  setTimeout(function() {
    if (!fired && typeof fbq === "function") {
      fbq("trackCustom", "time_spend_60_sec");
      fired = true;
    }
  }, 60000);

  document.addEventListener("visibilitychange", function() {
    if (document.hidden) {
      fired = true;
    }
  });
})();